module.exports = __webpack_public_path__ + "static/img/2.61159f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/2.png
// module id = vBHn
// module chunks = 0